const ADMIN_UPDATE_BILLING = 'admin-update-billing-compliance';
const AGENCY_APPOINTMENTS = 'agency_appointments';
const AGENCY_DASHBOARD_PREREQ = 'agency_dashboard_prereq';
const AWS_FLAG = 'aws_flag';
const CLAIMS_QUESTIONS = 'claims_questions';
const CLIENT_PROFILE = 'client_profile';
const CLOUDFLARE = 'cloudflare';
const CMAIL = 'cmail';
const COWBELL_BIND_QUOTE_WORKFLOW = 'cowbell_bind_quote_workflow_ff';
const COWBELL_FACTORS_DECLINE = 'cowbell_factors_decline';
const COWBELL_GENERATE_RENEWAL_QUOTE = 'cowbell_generate_renewal_quote';
const ELIGIBLE_PRODUCTS = 'eligible_products';
const EXCESS_FLOW = 'excess_flow';
const FLAT_CANCEL = 'flat_cancel';
const LANGUAGE_SELECTOR = 'language_selector';
const MAINTENANCE_MODE = 'maintenance-mode';
const MAINTENANCE_MODE_US = 'maintenance-mode-us';
const MAINTENANCE_MODE_UK = 'maintenance-mode-uk';
const MAINTENANCE_MODE_AU = 'maintenance-mode-au';
const MARSH_AGENCY = 'marsh_agency';
const MMA_ENDORSEMENT = 'mma_endorsement';
// Gates the ENTIRE Ask Moo experience for Brokers (AGENCY) and Policyholders
// (CUSTOMER) — not just the Cyber Pulse agent. Cowbell is unaffected (always
// on). Default off → these personas don't see Ask Moo until enabled. OMNI-484.
const ASK_MOO_BROKERS_POLICYHOLDERS = 'ask_moo_brokers_policyholders';
// The whole underwriter draft experience, on one switch: the view publishes
// itself to the Moo chat agent, the agent can propose changes into it, those
// changes are priced before they are shown, and every change — the agent's and
// the underwriter's own — lands in a pending overlay decided per row in place
// on the quote, instead of committing on change. Default off.
//
// This replaced four flags (…_read, …_write, …_preview and this one). They
// gated stages of one feature that nobody ever ran apart, and the combinations
// they allowed were mostly states nobody designed — an agent proposing into a
// view with no way to show the proposal, a preview priced against a draft that
// did not exist. The other three keys can be retired in GrowthBook.
const MOO_VIEW_BROKER_DRAFT = 'moo_view_broker_draft';
// Extends MOO_VIEW_BROKER_DRAFT to excess (Prime One Plus) UW quotes. Default
// off: the draft layer cannot describe the excess tower yet, so edits staged
// there showed a banner with a change count and no rows (OMNI-1242).
const MOO_VIEW_BROKER_DRAFT_EXCESS = 'moo_view_broker_draft_excess';
// JSON-valued flag that narrows the Moo chat panel's agent catalog to an
// explicit allow-list of human-readable agent ids:
// `{ "allowedAgents": ["default-moo", "cyber-pulse", ...] }`. Trims the panel
// for a specific audience (a demo account); it is not an access control, and
// it fails open — absent, empty, or matching nothing all show the full server
// catalog. Chat panel only — Moo Studio's agent lists are unaffected.
const LIMIT_MOO_AGENTS = 'limit_moo_agents';
// Shows the unified `underwriter` agent (Cyber, Tech E&O and ML in one) in the
// Moo chat panel in place of the three line agents, which it then hides.
// Default OFF: the panel shows the line agents and hides the unified one.
// Chat panel only; Moo Studio still lists all four.
const UNIFIED_UW_AGENT = 'unified_uw_agent';
const OPT_IN_NEW_AGENT_EXPERIENCE = 'opt_in_new_agent_experience';
const P100_RENEWAL_BIND_FLOW = 'p100-renewal-bind-flow';
const P250_ENDORSEMENT_BYPASS_RULES = 'p250-endorsement-bypass-rules';
// New Prime 250 business is written as P250X rather than P250. All-or-nothing
// and platform-wide: on hides the legacy P250 card and shows the P250X one in
// its place, off returns new business to P250 without a deploy. Read by
// fir-account under the same key, so the card shown and the key written cannot
// disagree. Governs new business only — the at-renewal P250-to-P250X migration
// is a separate rule (FPX-8516 / FPX-8538).
const PRIME_250_NEW_BUSINESS_ON_P250X = 'prime_250_new_business_on_p250x';
const PRIME_ONE = 'prime_one';
const PRIME_ONE_US = 'prime_one_us';
const PRIME_ONE_PLUS_US = 'prime_one_plus_us';
const PRIME_ONE_UW = 'prime_one_uw';
const PRIME_TECH_PLUS = 'prime-tech';
const PRODUCT_SELECTOR = 'product_selector';
const RESTRICT_UW_CARRIER_CHANGE = 'restrict_uw_carrier_change';
const RETREADS = 'retreads';
const UNDO_CANCELLED_POLICY = 'undo-cancelled-policy';
const PRIME_TECH = 'prime_tech';
const P_ONE_PLUS = 'p_one_plus';
const PRIME_ONE_TECH_PLUS = 'prime_one_tech_plus';
const UK_ENVIRONMENT = 'uk_environment';
const AU_ENVIRONMENT = 'au_environment';
const AGENCY_COMMISSION_ENHANCEMENTS = 'agency_commission_enhancements';
const CLAIMS_DIARY = 'claims_diary';
const BUSINESS_TYPE_IN_CARRIER_RISK_PROFILE =
  'business_type_in_carrier_risk_profile';
const SUBMISSIONS_MAILING_ADDRESS = 'submissions_mailing_address';
const OWNERSHIP_TYPE = 'ownership_type';
const PRIME_TECH_CANCEL = 'prime_tech_cancel';
const OBD_TREATY_ENHANCEMENT = 'obd_treaty_enhancement';
const REBUILD_RENEWALS = 'rebuild_renewals';
const SCBFE_FINANCIALS = 'scbfe_financials';
const IS_START_DATE_FREE_SELECTION = 'allow_uw_mte_start_date_free_selection'; // PS-5194 P250 only
const IS_END_DATE_FREE_SELECTION = 'allow_uw_mte_end_date_free_selection'; // PS-5194 P250 only
const P100_PRO_X_DYNAMIC_FIELDS = 'p100_pro_x_dynamic_forms';
const ENDORSEMENTS_X = 'endorsements_x';
const ENDORSEMENTS_X_COVERAGES_PRIME_ONE_PLUS_US =
  'endorsements_x_coverages_PRIME_ONE_PLUS_US'; // FPX-7613 excess only
const CANCELLATION_X = 'cancellation_x';
const CANCELLATION_X_PRIME_ONE_AU = 'cancellation_x_PRIME_ONE_AU';
const NOC_X = 'noc_x';
const TAIL_X = 'tail_x';
const TAIL_FOR_EXCESS = 'tail_for_excess';
const CANCEL_REWRITE_ENHANCED_UI = 'cancel_rewrite_enhanced_ui';
const LEEN_CONNECTORS_V2 = 'leen_connectors_enhancement';
const CRS_ENABLE = 'crs_enable';
const CRS_ENABLE_SELF_SERVE = 'crs_enable_self_serve';
const CRS_WIZER_FOR_AGENCIES = 'crs_wizer_for_agencies';
const REVERT_REVISION = 'revert_revision';
const PRIME_ONE_TECH = 'prime_one_tech';
const ONE_ACCT_MULTI_LINE = 'account_multi_line';
const P100_MTE_ANI = 'p100_mte_ani';
const EDIT_ZSP_QUOTE = 'edit_zsp_quote';
const ACCOUNT_EDIT = 'account_edit';
const SHOW_REFERRAL_STRATEGY = 'show_referral_strategy';
const EDIT_QUOTE_PHASE_1_ONE_SHOT_SAVING = 'edit_quote_phase1_one_shot_saving';
const SSO_LOGIN = 'sso';
const MAGIC_LINK_LOGIN = 'magic-link-login';
const ALLOW_ZSP_CANCEL = 'allow_zsp_cancel';
const ZSP_RENEWALS_ENHANCED_UI = 'zsp_renewals_enhanced_ui';
const RENEWAL_ZSP_OPT_OUT_ENABLED_UI = 'renewal_zsp_opt_out_enabled_ui';
const ZBELL_LOSSRUNS = 'zbell_lossruns';
const COVERAGE_FORMS_ENABLED = 'coverage_forms_enabled';
const POOLS = 'pools';
const POOLS_ENHANCEMENTS = 'pools_enhancements';
const POOLS_ACCOUNT_GROUP_NAME_SEARCH_ENHANCEMENTS =
  'pools_account_group_name_search_enhancements';
const POOL_MTE = 'pool_mte';
const POOL_CREATE_TIERS = 'pool_create_tiers';
const PROGRAM_ENHANCEMENTS = 'program_enhancements';
const X_PRODUCTS_BOR = 'x_products_bor';
const RENEWAL_SUBMISSIONS_QUOTE = 'renewal_quoting_fe';
const RENEWAL_SUBMISSION_CONFIDENCE_UI = 'renewal_submission_confidence_ui';
const SUBMISSIONS_WORKSPACE = 'submissions_workspace';
const MULTI_YEAR_POLICY = 'multi_year_policy';
const SUBMISSIONS_DOC_RAG = 'submissions_doc_rag';
const SHOW_RISK_REPORT_DOWNLOAD = 'show_risk_report_download';
const HUB_AGENT_LICENSE = 'hub_agent_license';
const P250_Q1_RATE_UPDATES = 'p250_q1_updates';
const BOOST_V6_BLOCK_EARLY_QUOTING_RENEWALS =
  'boost_v6_block_early_quoting_renewals';
const SPOTLIGHT_V2 = 'spotlight_v2';
const SPOTLIGHT_V2_PG_SOURCE = 'spotlight_v2_pg_source';
const FORCE_ENABLE_MTE_P100 = 'force_enable_mte_p100';
const RENEWAL_PRODUCT_SWITCH = 'renewal_product_switch';
const P100_TO_P100_PRO_RENEWAL_MIGRATION = 'p100_to_p100_pro_renewal_migration';

const DISABLE_COVERAGE_DIFF_SUMMARY_P100_MTE =
  'disable_coverage_diff_summary_p100_mte';
const P100_MTE_ALLOW_COVERAGE_UPDATES_BOOST_V6 =
  'p100_mte_allow_coverage_updates_boost_v6';
const P100_FLEXIBLE_POLICY_TERM = 'p100_flexible_policy_term';
const P250_TO_PRIME_ONE_US_RENEWAL_MIGRATION_PHASE_2 =
  'p250_to_prime_one_us_renewal_migration_phase_2';
const PRIME_PLUS_TO_PRIME_ONE_PLUS_US_RENEWAL_MIGRATION =
  'prime_plus_to_prime_one_plus_us_renewal_migration';
// fir-account renews every P250 policy on P250X while this is on, so agencies
// are not offered a manual P250 renewal (FPX-10186).
const P250_TO_P250X_RENEWAL_MIGRATION = 'p250_to_p250x_renewal_migration';
const DOCX_UPLOAD_UI = 'docx_upload_ui';
const CARRIER_SUBMISSIONS = 'carrier_submissions';
const ENABLE_DYNAMIC_FORMS = 'enable_dynamic_forms';
// FIR-20698 — gates the P100/P250 admin renewal tables fetching from the
// postgres renewals endpoint (same one Prime X renewals uses) instead of the
// Elasticsearch renewal-submission search endpoint. Default OFF.
const RENEWAL_SUBMISSIONS_PG_VIEW = 'renewal_submissions_p100_p250_pg_view';

// FPX-8925 — gates the Update Billing item on the Cowbell Px quote and binder
// row menus, which set Direct Bill / Agency Bill per record. UI only: the
// FPX-8924 backend ships unflagged and is inert until an override is written.
// Default OFF.
const PX_BILLING_TYPE_OVERRIDE = 'px_billing_type_override';
// P100X-77 — gates the admin States table's "View coverages" drawer, backed by
// fir-account's mothership state endpoints. Default OFF.
const SUPPORTED_STATES_REVISED = 'supported_states_revised';
// FIR-21357 — gates policyholder web claim intake: the Claims list's "Open new
// claim" button, the dashboard tile's link to the form, and the
// /customer/claims/new route. Off sends policyholders to the claims list and the
// phone number instead. Default OFF.
const POLICYHOLDER_OPEN_NEW_CLAIM = 'policyholder_open_new_claim';

// Loads the Salesforce Embedded Messaging chat button on the Agency and
// Customer dashboards. Default OFF — the widget does not load until enabled.
const SALESFORCE_CHAT = 'salesforce_chat';

// FRAN-117 — hides all of franchise (Admin -> Franchises and the franchise
// jump) until launch. Console only; off in production.
const FRANCHISE = 'franchise';

// EXP-931 — gates the non-renewal actions (Send Non-Renewal, review screen
// decision, notice preview). Same key fir-account reads. Default OFF.
const NON_RENEWAL_WORKFLOW = 'non_renewal_workflow';

export const FEATURE_FLAG_KEYS = {
  ADMIN_UPDATE_BILLING,
  AGENCY_APPOINTMENTS,
  AGENCY_DASHBOARD_PREREQ,
  AWS_FLAG,
  CLAIMS_QUESTIONS,
  CLIENT_PROFILE,
  CLOUDFLARE,
  CMAIL,
  COWBELL_BIND_QUOTE_WORKFLOW,
  COWBELL_FACTORS_DECLINE,
  COWBELL_GENERATE_RENEWAL_QUOTE,
  ELIGIBLE_PRODUCTS,
  EXCESS_FLOW,
  FLAT_CANCEL,
  LANGUAGE_SELECTOR,
  MAINTENANCE_MODE,
  MAINTENANCE_MODE_US,
  MAINTENANCE_MODE_UK,
  MAINTENANCE_MODE_AU,
  MARSH_AGENCY,
  MMA_ENDORSEMENT,
  ASK_MOO_BROKERS_POLICYHOLDERS,
  MOO_VIEW_BROKER_DRAFT,
  MOO_VIEW_BROKER_DRAFT_EXCESS,
  LIMIT_MOO_AGENTS,
  UNIFIED_UW_AGENT,
  OPT_IN_NEW_AGENT_EXPERIENCE,
  P100_RENEWAL_BIND_FLOW,
  P250_ENDORSEMENT_BYPASS_RULES,
  P_ONE_PLUS,
  PRIME_ONE_TECH_PLUS,
  PRIME_ONE_UW,
  PRIME_ONE,
  PRIME_ONE_US,
  PRIME_ONE_PLUS_US,
  PRIME_TECH,
  PRIME_TECH_PLUS,
  PRODUCT_SELECTOR,
  RESTRICT_UW_CARRIER_CHANGE,
  RETREADS,
  UNDO_CANCELLED_POLICY,
  UK_ENVIRONMENT,
  AU_ENVIRONMENT,
  AGENCY_COMMISSION_ENHANCEMENTS,
  CLAIMS_DIARY,
  BUSINESS_TYPE_IN_CARRIER_RISK_PROFILE,
  SUBMISSIONS_MAILING_ADDRESS,
  OWNERSHIP_TYPE,
  PRIME_TECH_CANCEL,
  OBD_TREATY_ENHANCEMENT,
  REBUILD_RENEWALS,
  SCBFE_FINANCIALS,
  IS_START_DATE_FREE_SELECTION,
  IS_END_DATE_FREE_SELECTION,
  P100_PRO_X_DYNAMIC_FIELDS,
  ENDORSEMENTS_X,
  ENDORSEMENTS_X_COVERAGES_PRIME_ONE_PLUS_US,
  CANCELLATION_X,
  CANCELLATION_X_PRIME_ONE_AU,
  NOC_X,
  TAIL_X,
  TAIL_FOR_EXCESS,
  CANCEL_REWRITE_ENHANCED_UI,
  LEEN_CONNECTORS_V2,
  CRS_ENABLE,
  CRS_ENABLE_SELF_SERVE,
  CRS_WIZER_FOR_AGENCIES,
  REVERT_REVISION,
  PRIME_ONE_TECH,
  ONE_ACCT_MULTI_LINE,
  P100_MTE_ANI,
  EDIT_ZSP_QUOTE,
  ACCOUNT_EDIT,
  SHOW_REFERRAL_STRATEGY,
  EDIT_QUOTE_PHASE_1_ONE_SHOT_SAVING,
  SSO_LOGIN,
  MAGIC_LINK_LOGIN,
  ALLOW_ZSP_CANCEL,
  ZSP_RENEWALS_ENHANCED_UI,
  RENEWAL_ZSP_OPT_OUT_ENABLED_UI,
  ZBELL_LOSSRUNS,
  COVERAGE_FORMS_ENABLED,
  POOLS,
  POOLS_ENHANCEMENTS,
  POOLS_ACCOUNT_GROUP_NAME_SEARCH_ENHANCEMENTS,
  POOL_MTE,
  POOL_CREATE_TIERS,
  PROGRAM_ENHANCEMENTS,
  X_PRODUCTS_BOR,
  RENEWAL_SUBMISSIONS_QUOTE,
  RENEWAL_SUBMISSION_CONFIDENCE_UI,
  SUBMISSIONS_WORKSPACE,
  MULTI_YEAR_POLICY,
  SUBMISSIONS_DOC_RAG,
  SHOW_RISK_REPORT_DOWNLOAD,
  HUB_AGENT_LICENSE,
  P250_Q1_RATE_UPDATES,
  BOOST_V6_BLOCK_EARLY_QUOTING_RENEWALS,
  SPOTLIGHT_V2,
  SPOTLIGHT_V2_PG_SOURCE,
  FORCE_ENABLE_MTE_P100,
  RENEWAL_PRODUCT_SWITCH,
  P100_TO_P100_PRO_RENEWAL_MIGRATION,
  DISABLE_COVERAGE_DIFF_SUMMARY_P100_MTE,
  P100_MTE_ALLOW_COVERAGE_UPDATES_BOOST_V6,
  P100_FLEXIBLE_POLICY_TERM,
  P250_TO_PRIME_ONE_US_RENEWAL_MIGRATION_PHASE_2,
  PRIME_PLUS_TO_PRIME_ONE_PLUS_US_RENEWAL_MIGRATION,
  P250_TO_P250X_RENEWAL_MIGRATION,
  DOCX_UPLOAD_UI,
  CARRIER_SUBMISSIONS,
  ENABLE_DYNAMIC_FORMS,
  RENEWAL_SUBMISSIONS_PG_VIEW,
  PRIME_250_NEW_BUSINESS_ON_P250X,
  PX_BILLING_TYPE_OVERRIDE,
  SALESFORCE_CHAT,
  FRANCHISE,
  SUPPORTED_STATES_REVISED,
  POLICYHOLDER_OPEN_NEW_CLAIM,
  NON_RENEWAL_WORKFLOW,
} as const;
